module.exports = __webpack_public_path__ + "img/gg-25.prt.06ecc009.jpg";